module.exports = __webpack_public_path__ + "img/info.724548e0.svg";